<div class="ap-root" dir="rtl">

  <!-- Loading -->
  @if (loading) {
    <div class="ap-state">
      <div class="ap-spinner"></div>
      <span class="ap-state-lbl">טוען...</span>
    </div>
  }

  <!-- Error -->
  @if (error && !loading) {
    <div class="ap-state">
      <div class="ap-state-icon"><i class="fa fa-exclamation-triangle"></i></div>
      <p class="ap-state-lbl">לא ניתן לטעון את פרטי החברה</p>
      <button class="ap-retry" (click)="ngOnInit()">
        <i class="fa fa-refresh"></i> נסה שוב
      </button>
    </div>
  }

  <!-- Main content -->
  @if (company && !loading) {
    <!-- ══ Hero ══════════════════════════════════════════════════════════════ -->
    <div class="ap-hero" dir="rtl">
      <div class="ap-hero-inner">
        <div class="ap-hero-logo">
          @if (company.logo) {
            <img [src]="company.logo" [alt]="company.name" />
          }
          @if (!company.logo) {
            <i class="fa fa-building-o"></i>
          }
        </div>
        <div class="ap-hero-txt">
          <h1 class="ap-hero-name">{{ company.name }}</h1>
          @if (company.tagline) {
            <p class="ap-hero-tag">{{ company.tagline }}</p>
          }
          <div class="ap-hero-chips">
            @if (company.city) {
              <span class="ap-chip">
                <i class="fa fa-map-marker"></i>&nbsp;{{ company.city }}
              </span>
            }
            @if (company.founded_year) {
              <span class="ap-chip">
                <i class="fa fa-calendar-o"></i>&nbsp;פעילים מאז {{ company.founded_year }}
              </span>
            }
          </div>
        </div>
      </div>
    </div>
    <!-- ══ Body ══════════════════════════════════════════════════════════════ -->
    <div class="ap-body" dir="rtl">
      <div class="ap-grid">
        <!-- ─ Main column ─────────────────────────────────────────────────── -->
        <div class="ap-col-main">
          <!-- About text -->
          @if (company.description) {
            <div class="ap-card" dir="rtl">
              <div class="ap-card-head">
                <span class="ap-card-bar"></span>
                <h2 class="ap-card-title">אודות החברה</h2>
              </div>
              <p class="ap-desc" dir="rtl">{{ company.description }}</p>
            </div>
          }
          <!-- Contact -->
          <div class="ap-card" dir="rtl">
            <div class="ap-card-head">
              <span class="ap-card-bar"></span>
              <h2 class="ap-card-title">{{ 'sale4you.about.contact' | translate }}</h2>
            </div>
            <div class="ap-clist" dir="rtl">
              @if (company.phone) {
                <div class="ap-crow" (click)="callPhone(company.phone)" dir="rtl">
                  <div class="ap-cicon ap-ci-phone"><i class="fa fa-phone"></i></div>
                  <div class="ap-cinfo" dir="rtl">
                    <span class="ap-clabel">טלפון</span>
                    <span class="ap-cval">{{ formatPhone(company.phone) }}</span>
                  </div>
                  <i class="fa fa-angle-left ap-carrow"></i>
                </div>
              }
              @if (company.whatsapp) {
                <div class="ap-crow" (click)="openWhatsapp(company.whatsapp)" dir="rtl">
                  <div class="ap-cicon ap-ci-wa"><i class="fa fa-whatsapp"></i></div>
                  <div class="ap-cinfo" dir="rtl">
                    <span class="ap-clabel">WhatsApp</span>
                    <span class="ap-cval">{{ formatPhone(company.whatsapp) }}</span>
                  </div>
                  <i class="fa fa-angle-left ap-carrow"></i>
                </div>
              }
              @if (company.email) {
                <div class="ap-crow" (click)="openEmail(company.email)" dir="rtl">
                  <div class="ap-cicon ap-ci-mail"><i class="fa fa-envelope-o"></i></div>
                  <div class="ap-cinfo" dir="rtl">
                    <span class="ap-clabel">דוא"ל</span>
                    <span class="ap-cval ltr-val">{{ company.email }}</span>
                  </div>
                  <i class="fa fa-angle-left ap-carrow"></i>
                </div>
              }
              @if (company.address || company.city) {
                <div class="ap-crow"
                  (click)="openMaps(company.address, company.city)" dir="rtl">
                  <div class="ap-cicon ap-ci-addr"><i class="fa fa-map-marker"></i></div>
                  <div class="ap-cinfo" dir="rtl">
                    <span class="ap-clabel">כתובת</span>
                    <span class="ap-cval">
                      {{ company.address }}@if (company.address && company.city) {
                      ,
                      }{{ company.city }}
                    </span>
                  </div>
                  <i class="fa fa-angle-left ap-carrow"></i>
                </div>
              }
              @if (company.website) {
                <div class="ap-crow" (click)="openLink(company.website)" dir="rtl">
                  <div class="ap-cicon ap-ci-web"><i class="fa fa-globe"></i></div>
                  <div class="ap-cinfo" dir="rtl">
                    <span class="ap-clabel">אתר אינטרנט</span>
                    <span class="ap-cval ap-cval-link ltr-val">{{ company.website }}</span>
                  </div>
                  <i class="fa fa-angle-left ap-carrow"></i>
                </div>
              }
            </div>
          </div>
          <!-- Social links -->
          @if (company.social_links?.length) {
            <div class="ap-card" dir="rtl">
              <div class="ap-card-head">
                <span class="ap-card-bar"></span>
                <h2 class="ap-card-title">{{ 'sale4you.about.social' | translate }}</h2>
              </div>
              <div class="ap-social" dir="rtl">
                @for (link of company.social_links; track link) {
                  <button
                    class="ap-soc-item"
                    (click)="openLink(link.url)"
                    [title]="link.platform_display">
                    <div class="ap-soc-icon">
                      <i class="fa {{ socialCfg(link.platform).icon }}"
                      [style.color]="socialCfg(link.platform).color"></i>
                    </div>
                    <span class="ap-soc-name">{{ link.platform_display }}</span>
                  </button>
                }
              </div>
            </div>
          }
        </div>
        <!-- ─ Side column: Hours ───────────────────────────────────────────── -->
        @if (company.business_hours?.length) {
          <div class="ap-col-side">
            <div class="ap-card ap-hours-sticky" dir="rtl">
              <div class="ap-card-head">
                <span class="ap-card-bar"></span>
                <h2 class="ap-card-title">{{ 'sale4you.about.hours' | translate }}</h2>
              </div>
              <div class="ap-hlist" dir="rtl">
                @for (hour of company.business_hours; track hour) {
                  <div
                    class="ap-hrow"
                    [class.ap-today]="isToday(hour)"
                    dir="rtl">
                    <div class="ap-hday-wrap">
                      @if (isToday(hour)) {
                        <span class="ap-today-badge">היום</span>
                      }
                      <span class="ap-hday">{{ hour.day_display }}</span>
                    </div>
                    <span class="ap-htime" [class.ap-closed]="hour.is_closed">
                      {{ hoursLabel(hour) }}
                    </span>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div><!-- /grid -->
      <!-- Footer -->
      <div class="ap-footer" dir="rtl">
        <span>© {{ company.founded_year || '' }} {{ company.name }} — כל הזכויות שמורות</span>
      </div>
    </div><!-- /body -->
  }
</div>
